/* LUNURA MEXICO — comportements du thème (carrousels, galerie, bandeau, sélecteur de pays, barre collante, panier) */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  /* ---------- Carrousel générique ---------- */
  function Slider(root, opts) {
    this.root = root; this.o = opts; this.i = 0;
    this.track = root.querySelector(':scope > .splide__track') || root.querySelector('.splide__track');
    this.list = this.track && this.track.querySelector('.splide__list');
    if (!this.list) return;
    this.slides = Array.prototype.slice.call(this.list.children);
    root.classList.add('is-initialized', 'is-active');
    var arrows = root.querySelector(':scope > .splide__arrows') || (root.parentElement && root.parentElement.querySelector(':scope > .splide__arrows'));
    this.prev = arrows && arrows.querySelector('.splide__arrow--prev');
    this.next = arrows && arrows.querySelector('.splide__arrow--next');
    var self = this;
    if (this.prev) this.prev.addEventListener('click', function (e) { e.preventDefault(); self.go(self.i - 1); });
    if (this.next) this.next.addEventListener('click', function (e) { e.preventDefault(); self.go(self.i + 1); });
    if (opts.pagination) {
      this.pag = document.createElement('ul'); this.pag.className = 'splide__pagination';
      root.appendChild(this.pag);
    }
    this.drag();
    this.layout();
    window.addEventListener('resize', function () { self.layout(); });
  }
  Slider.prototype.perPage = function () { return mq.matches ? this.o.perPageMobile : this.o.perPage; };
  Slider.prototype.layout = function () {
    var pp = this.perPage(), gap = this.o.gap;
    var w = 'calc((100% - ' + (gap * (Math.ceil(pp) - 1)) + 'px) / ' + pp + ')';
    if (pp % 1) w = 'calc((100% - ' + (gap * Math.floor(pp)) + 'px) / ' + pp + ')';
    this.slides.forEach(function (s) { if (!s.classList.contains('product-media-gallery__thumbnail')) { s.style.width = w; s.style.marginRight = gap + 'px'; } });
    this.max = Math.max(0, this.slides.length - Math.floor(pp));
    if (this.pag) {
      var n = this.max + 1, self = this;
      this.pag.innerHTML = '';
      this.pag.style.display = n > 1 && (mq.matches ? this.o.paginationMobile : this.o.pagination) ? '' : 'none';
      for (var k = 0; k < n; k++) (function (k) {
        var li = document.createElement('li'); var b = document.createElement('button');
        b.className = 'splide__pagination__page'; b.type = 'button'; b.addEventListener('click', function () { self.go(k); });
        li.appendChild(b); self.pag.appendChild(li);
      })(k);
    }
    this.go(Math.min(this.i, this.max), true);
  };
  Slider.prototype.go = function (i, silent) {
    i = Math.max(0, Math.min(this.max, i)); this.i = i;
    var s = this.slides[i]; var x = s ? s.offsetLeft - this.slides[0].offsetLeft : 0;
    this.list.style.transform = 'translateX(' + (-x) + 'px)';
    this.slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === i); });
    if (this.prev) this.prev.disabled = i === 0;
    if (this.next) this.next.disabled = i >= this.max;
    if (this.pag) Array.prototype.forEach.call(this.pag.querySelectorAll('button'), function (b, k) { b.classList.toggle('is-active', k === i); });
    if (!silent && this.onChange) this.onChange(i);
  };
  Slider.prototype.drag = function () {
    var self = this, x0 = null, t0 = 0, moved = false;
    this.track.classList.add('splide__track--draggable');
    this.track.addEventListener('pointerdown', function (e) { x0 = e.clientX; moved = false; t0 = Date.now(); });
    this.track.addEventListener('pointermove', function (e) { if (x0 !== null && Math.abs(e.clientX - x0) > 8) moved = true; });
    function end(e) {
      if (x0 === null) return; var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) self.go(self.i + (dx < 0 ? 1 : -1));
    }
    this.track.addEventListener('pointerup', end);
    this.track.addEventListener('pointercancel', function () { x0 = null; });
    this.track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    var tx = null;
    this.track.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    this.track.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(dx) > 40) self.go(self.i + (dx < 0 ? 1 : -1)); }, { passive: true });
  };

  function num(el, k, d) { var v = parseFloat(el.getAttribute(k)); return isNaN(v) ? d : v; }
  function flag(el, k) { return el.getAttribute(k) === 'true'; }

  function initSliders() {
    document.querySelectorAll('slider-component').forEach(function (sc) {
      var gallery = sc.classList.contains('product-media-gallery');
      if (gallery) {
        var mainEl = sc.querySelector('.product-media-gallery-main-slider');
        var thumbsEl = sc.querySelector('.product-media-gallery__thumbnails');
        if (!mainEl) return;
        var main = new Slider(mainEl, { perPage: 1, perPageMobile: 1, gap: num(sc, 'data-gap', 20) });
        if (thumbsEl) {
          var th = Array.prototype.slice.call(thumbsEl.querySelectorAll('.product-media-gallery__thumbnail'));
          var tl = thumbsEl.querySelector('.splide__list');
          thumbsEl.classList.add('is-initialized', 'is-active');
          th.forEach(function (t, k) { t.addEventListener('click', function () { main.go(k); }); });
          main.onChange = function (i) {
            th.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
            var t = th[i]; if (!t || !tl) return;
            var track = thumbsEl.querySelector('.splide__track');
            var over = t.offsetLeft + t.offsetWidth - track.clientWidth;
            tl.style.transform = 'translateX(' + (-Math.max(0, over > 0 ? over : 0)) + 'px)';
          };
          main.onChange(0);
        }
        return;
      }
      var root = sc.querySelector('.splide'); if (!root) return;
      new Slider(root, {
        perPage: num(sc, 'data-per-page-desktop', 1), perPageMobile: num(sc, 'data-per-page-mobile', 1), gap: num(sc, 'data-gap', 15),
        pagination: flag(sc, 'data-show-pagination'), paginationMobile: flag(sc, 'data-show-pagination-mobile')
      });
    });
  }

  /* ---------- Bandeau défilant ---------- */
  function initMarquees() {
    document.querySelectorAll('marquee-component').forEach(function (m) {
      var w = m.querySelector('.marquee__wrapper'); if (!w) return;
      var contents = w.querySelectorAll('.marquee__content');
      if (contents.length === 1) w.appendChild(contents[0].cloneNode(true));
      var speed = parseFloat(m.getAttribute('data-speed-factor')) || 20;
      requestAnimationFrame(function () {
        var half = w.scrollWidth / 2;
        w.style.setProperty('--marquee-duration', Math.max(8, half / (speed * 2.5)) + 's');
      });
    });
  }

  /* ---------- Sélecteur pays / devise ---------- */
  function initDropdowns() {
    document.querySelectorAll('dropdown-component').forEach(function (d) {
      var t = d.querySelector('.dropdown-toggle'); if (!t) return;
      t.addEventListener('click', function (e) { e.stopPropagation(); d.classList.toggle('is-open'); });
      d.querySelectorAll('.localization-form__country').forEach(function (li) {
        li.addEventListener('click', function () {
          var f = li.closest('form'); var inp = f && f.querySelector('input[name="country_code"]');
          if (inp) { inp.value = li.getAttribute('data-value'); f.submit(); }
        });
      });
    });
    document.addEventListener('click', function () { document.querySelectorAll('dropdown-component.is-open').forEach(function (d) { d.classList.remove('is-open'); }); });
  }

  /* ---------- Barre « Agregar al carrito » collante (mobile) ---------- */
  function initStickyAtc() {
    var st = document.querySelector('sticky-add-to-cart'); if (!st) return;
    function upd() { st.setAttribute('data-active', mq.matches ? 'true' : 'false'); }
    upd(); mq.addEventListener ? mq.addEventListener('change', upd) : mq.addListener(upd);
  }

  /* ---------- Icône panier ---------- */
  function initCartIcon() {
    document.querySelectorAll('cart-icon, .header__icon-cart').forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.kachingCartApi) window.kachingCartApi.openCart(); else window.location.href = '/cart';
      });
    });
  }


  // Comparateur avant/après (glisser ou cliquer)
  if (!customElements.get('before-after-component')) {
    customElements.define('before-after-component', class extends HTMLElement {
      connectedCallback() {
        var el = this, sl = el.querySelector('[data-ref="slider"]'), bi = el.querySelector('[data-ref="before-image"]'), drag = false;
        if (!sl || !bi) return;
        function set(p) { p = Math.max(0, Math.min(100, p)); sl.style.left = p + '%'; bi.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)'; }
        function at(e) { var r = el.getBoundingClientRect(), x = e.touches ? e.touches[0].clientX : e.clientX; set((x - r.left) / r.width * 100); }
        set(parseInt(el.dataset.defaultPosition) || 50);
        function start(e) { drag = true; e.preventDefault(); }
        sl.addEventListener('mousedown', start); sl.addEventListener('touchstart', start, { passive: false });
        document.addEventListener('mousemove', function (e) { if (drag) { e.preventDefault(); at(e); } });
        document.addEventListener('touchmove', function (e) { if (drag) { e.preventDefault(); at(e); } }, { passive: false });
        document.addEventListener('mouseup', function () { drag = false; }); document.addEventListener('touchend', function () { drag = false; });
        el.addEventListener('click', function (e) { if (!drag) at(e); });
      }
    });
  }

  function boot() { initSliders(); initMarquees(); initDropdowns(); initStickyAtc(); initCartIcon(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
